import { vars } from '@repo/config';
import { createAuthRequestHeaders } from './helper';

interface ISelfDeleteResponse {
  success: boolean;
  error?: string;
}

export async function selfDeleteUser(cookieHeader: string): Promise<ISelfDeleteResponse> {
  const url = new URL('/self-delete', vars.url.identityUrl);

  const response = await fetch(url.toString(), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...createAuthRequestHeaders(cookieHeader),
    },
  });

  if (!response.ok) {
    const errorData = (await response.json()) as { error?: string };
    return { success: false, error: errorData.error || 'Failed to delete account' };
  }

  return { success: true };
}
